export default __webpack_public_path__ + "static/IBMPlexSans-SemiBold-Latin1-578aae4082fb12898fe3fad4245c606d.woff2";